/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import app from '../config/confighttp'
import router from "../router";
import {
	Notification
} from 'element-ui';
import {
	Loading,
	Message,
	MessageBox
} from 'element-ui'
const API_TIMEROUT = 10 * 60 * 1000 // request timeout
// create an axios instance
const service = axios.create({
	baseURL: app.http_url, // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: API_TIMEROUT,
	headers: {
		'Content-Type': 'application/json-patch+json',
		'dtype': '1'
	}
})
// http请求拦截器
service.interceptors.request.use(
	config => {
		var token = localStorage.getItem('comm-token')

		if (token) {
			// 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers.Authorization = `${token}`
		}
		return config
	},
	error => {
		if (error.response.status === 401) {
			localStorage.removeItem('comm-token');
			localStorage.clear();
			Notification.error({
				title: '提示',
				message: '授权失效，请重新登录',
				duration: 2000
			})
			setTimeout(() => {
				location.reload();
			}, 200)
		} else {
			Notification.error({
				title: '提示',
				message: '系统异常，请刷新窗口重试',
				duration: 0
			})
		}
		return Promise.reject(error)
	}
)
// http响应拦截器
service.interceptors.response.use(

	response => {
		return response
	},
	error => {

		if (error.response) {
			switch (error.response.status) {
				case 401:
					// 返回 401 清除token信息并跳转到登录页面
					localStorage.removeItem('comm-token');
					localStorage.clear();
					Notification.error({
						title: '提示',
						message: '授权失效，请重新登录',
						duration: 2000
					})
					setTimeout(() => {
						location.reload();
					}, 200)
			}
		} else {
			Notification.error({
				title: '提示',
				message: '系统异常，请刷新窗口重试'
			})
		}
		return Promise.reject(error)
	}
)
export default service